


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const updateCaseWritingReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.UPDATE_CASE_WRITING:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.UPDATE_CASE_WRITING_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.UPDATE_CASE_WRITING_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
